(function ($, njm) {
    'use strict';

    njm.views.stickyQuote = Backbone.View.extend({
			
			initialize: function() {
				var $this = this;
				
                this.component = $('.comp-hero-sticky-quote');

				this.visible = false;

				this.expanded = false;
				
				this.focusableEls = null;
				
				this.firstFocusableEl = null;
				
				this.lastFocusableEl = null;
				
				this.activeElement = null;

				$(document).on({
					click: function(event) {
						$this.handleClick(event);
					}
				});

				$('.comp-hero-sticky-quote > .container > .button').on({
                    keydown: function (event) {
						$this.handleKeypress(event);
					}
				});

				window.onscroll = function(){
					$this.handleScroll();
				}
				
				this.handleScroll();
			},
		
			offsetHeight: function() {
				return $('.comp-inner-banner-quote').height() + $('.comp-inner-banner-quote').offset().top;
			},
			
			displayBtn: function() {
				//console.log('displayBtn()');
				this.component.addClass('active');
				this.component.find('> .container > .button').attr('tabindex', "0");
			},

			hideBtn: function() {
				//console.log('hideBtn()');
				this.component.removeClass('active');
				this.component.find('> .container > .button').attr('tabindex', "-1");
			},

			handleClick: function(event) {
				//console.log('handleClick()');
				
				if ($(event.target).closest('.comp-hero-sticky-quote > .container > .button').length === 1) {
					if (this.expanded) {
						this.collapse(event);
					} else {
						this.expand(event);
					}
				} else if ($(event.target).closest('.comp-dropdown-quote').length !== 1) {
					if (this.expanded) {
						this.collapse(event);
					}
				} 

			},

			handleKeypress: function(event) {
				//console.log('handleKeypress()');
				
				var key = event.which;

				if (key === 13 || key === 32) { //enter key
					this.handleClick(event);
				}

				if (event.which === 27) { //escape key
					this.collapse(event);
				}
			},
			
			handleTab: function(event) {
				//console.log('handleTab()');

				if (event.currentTarget === this.firstFocusableEl) {
					if (this.focusableEls.length === 1 && event.which === 9) {
						event.preventDefault();
					} else if(this.focusableEls.length > 1 && event.which === 9) {
						if (event.shiftKey) {
							this.lastFocusableEl.focus();
							event.preventDefault();
						}
					}
				}

				if (event.currentTarget === this.lastFocusableEl) {
					if (this.focusableEls.length === 1 && event.which === 9) {
						event.preventDefault();
					} else if(this.focusableEls.length > 1 && event.which === 9) {
						if (event.shiftKey) {
							return true;
						} else {
							this.firstFocusableEl.focus();
							event.preventDefault();
						}
					}
				}

			},
			
			setFocusableEls: function() {
				//console.log('setFocusableEls()');
				
				var $this = this;
				
				//this.clearFocusableEls();
				
				this.focusableEls = $('.comp-hero-sticky-quote').find('> .container > .button, .comp-dropdown-quote .selected, .screen.active a[href], .screen.active area[href], .screen.active input:not([disabled]):not([type=hidden]), .screen.active select:not([disabled]), .screen.active textarea:not([disabled]), .screen.active button:not([disabled]), .screen.active [tabindex="0"]');
				this.firstFocusableEl = this.focusableEls[0];
				this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
				
				//console.log($(this.firstFocusableEl));
				//console.log($(this.lastFocusableEl));
				
				$(this.firstFocusableEl).keydown(function(event){$this.handleTab(event)});
				$(this.lastFocusableEl).keydown(function(event){$this.handleTab(event)});
				
				this.firstFocusableEl.focus();
			},
			
			clearFocusableEls: function() {
				//console.log('clearFocusableEls()');
				
				this.focusableEls = null;				
				this.firstFocusableEl = null;
				this.lastFocusableEl = null;
			},

			expand: function(event) {
				//console.log('expand()');
				
				var quoteComponent = $('.comp-dropdown-quote'),
					quoteTarget = this.component.find('.container'),
					scrollBarWidth = window.innerWidth - $(document).width(),
					stickyComponentPadding = this.component.css('padding-right'),
					quoteContainer = $('.comp-inner-banner-quote .quote'),
					placeholder;
				
				placeholder = $('<div></div>');
				placeholder.css('height',quoteComponent.css('height'));
				placeholder.css({'display':'block','width':'100%'});
				
				stickyComponentPadding = stickyComponentPadding.slice(0,stickyComponentPadding.indexOf('px'));
				stickyComponentPadding = Number(stickyComponentPadding);

				event.preventDefault();

				quoteComponent.hide();
				quoteTarget.append(quoteComponent);
				quoteContainer.append(placeholder);
				quoteComponent.slideDown();

				this.expanded = true;

				this.component.addClass('expanded').removeClass('collapsed');
				$('body').addClass('sticky-quote-expanded');
				if (scrollBarWidth) {
					$('body').css('padding-right', scrollBarWidth + 'px');
				}
				this.component.css('padding-right', stickyComponentPadding + scrollBarWidth + 'px');
				
				this.activeElement = $(document.activeElement);
				this.setFocusableEls();
			},

			collapse: function(event) {
				
				//console.log('collapse()');

				if (this.expanded) {
					var quoteComponent = $('.comp-hero-sticky-quote .comp-dropdown-quote'),
                        quoteTarget = $('.comp-inner-banner-quote .content .quote'),
						stickyComponentPadding = this.component.css('padding-right');

					stickyComponentPadding = stickyComponentPadding.slice(0,stickyComponentPadding.indexOf('px'));
					stickyComponentPadding = Number(stickyComponentPadding);

					event.preventDefault();

					quoteComponent.slideUp(function(){
						quoteTarget.html('');
						quoteTarget.append(quoteComponent);
						quoteComponent.show();
					});

					this.expanded = false;

					this.component.addClass('collapsed').removeClass('expanded');
					$('body').removeClass('sticky-quote-expanded').css('padding-right','');
					this.component.css('padding-right','');
					
					this.clearFocusableEls();
					this.activeElement.focus();
					this.activeElement = null;
				}

				//console.log('compStickyQuote collapse()');
			},

			handleScroll: function() {
				//console.log('handleScroll()');

				if (window.pageYOffset > this.offsetHeight()) {
					this.displayBtn();
				} else {
					this.hideBtn();
				}

			}
		});

})(jQuery, njm);